module.exports = __webpack_public_path__ + "media/images/logo-outline-blue-601bc2c3981ddd0436bbcea54a605fb0.svg";